// Example use case: prevent the submission of a form when an
// <Input> inside it gets an Enter keypress.
export const cancelEnter = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    return false;
  }
};
